module.exports = __webpack_public_path__ + "img/preview.0a685c5f.jpg";